export { Comment } from './lib/models/comment.model';
export { CommentType } from './lib/models/comment-type.constat';
export { HashtagCount } from './lib/models/hashtag.model';
export { CommentsService } from './lib/services/comments.service';
export { CommentsDataModule } from './lib/comments-data.module';
